// Конфигурация аутентификации
export const authConfig = {
    // URL сервера аутентификации (можно изменить в настройках)
    // authServerUrl: 'https://ksvkvv.ru/api/auth/realms/echo-realm/protocol/openid-connect',
    baseUrl: 'https://api.ksvkvv.ru', //todo нормально обработать связку с урлом
    authServerUrl: 'https://api.ksvkvv.ru/auth/realms/echo-realm/protocol/openid-connect',
    clientId: 'echo-client',
    clientSecret: 'yQlrjupsYqYawAgEdC32sSlJGhlNgq2N',
    grant_type: 'password',
    scope: 'openid profile email',

    // Эндпоинты API
    endpoints: {
        login: '/token',
        register: '/auth/register',
        logout: '/logout',
        refresh: '/token',
        verify: '/auth/verify',
        userInfo: '/userinfo'
    },

    // Настройки токенов
    tokenStorageKey: 'auth_tokens',
    userStorageKey: 'user_data',
    refreshThreshold: 300000, // 5 минут до истечения токена

};

// Функция для обновления конфигурации (будет вызываться из настроек)
export const updateAuthConfig = (newConfig) => {
    Object.assign(authConfig, newConfig);
    localStorage.setItem('auth_config', JSON.stringify(authConfig));
};

// Загрузка сохраненной конфигурации
export const loadAuthConfig = () => {
    const saved = localStorage.getItem('auth_config');
    if (saved) {
        Object.assign(authConfig, JSON.parse(saved));
    }
};
